import { render, staticRenderFns } from "./inBooks.vue?vue&type=template&id=7fe74512&scoped=true&"
import script from "./inBooks.vue?vue&type=script&lang=js&"
export * from "./inBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe74512",
  null
  
)

export default component.exports